import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import UserInfoBox from "./UserInfoBox";

export default function() {
    return <Stack spacing={2}>
    <Typography className="Title" variant="bold">Run For Education</Typography>
    <UserInfoBox ownerName={'Ayesha Khan'} />
    <Typography>
        This Dubai Marathon 2023 brings an exciting opportunity for you to participate in one of the most
        glorious races of the year, raise awareness for the cause of education, and inspire others to join the
        TCF Movement. We invite you to fundraise for TCF on YallaGive and take on the challenge of running
        the Dubai Marathon to support education.

        he iconic Dubai Marathon will be held on 12th February, passionate runners will sprint toward the finish
        line in the shadow of the beautiful Burj Al Arab. The cheering crowds and breathtaking views of the city
        will energize participants as they dash through Dubai's stunning roads.

        For further details please call +97158 6616276.
    </Typography>
</Stack>
}